require('../../common/jv.i18n');

angular.module('jv.search.type.service', [
    'jv.Common.i18n'
])
.factory('getSearchTypes', [
    'i18n',
    function(i18n) {
        var options = {
            name: {
            	type: 'name',
            	placeholder: i18n.SEARCH_TYPE_NAME,
            	value: i18n.NAME,
            	icon: 'icon icon-profile',
            	order: 0
            },
            resume: {
                type: 'resume',
                placeholder: i18n.SEARCH_TYPE_RESUME,
                value: i18n.RESUME,
                icon: 'icon icon-text-view',
                order: 1
            },
            message: {
            	type: 'message',
            	placeholder: i18n.SEARCH_TYPE_MESSAGE,
            	value: i18n.MESSAGES,
            	icon: 'icon icon-message',
            	order: 2
            },
            note: {
                type: 'note',
                placeholder: i18n.SEARCH_TYPE_NOTE,
                value: i18n.NOTES,
                icon: 'icon icon-document',
                order: 3
            },
            all: {
            	type: 'all',
            	placeholder: i18n.SEARCH_TYPE_ALL,
            	value: i18n.ALL_KEYWORD,
            	icon: 'icon icon-search',
            	order: 4
            },
            exactMatch: {
                type: 'exactMatch',
                placeholder: i18n.SEARCH_TYPE_EXACT,
                value: i18n.EXACT_MATCH,
                icon: 'icon icon-radio-checked',
                order: 5
            }
        };
        return function(types) {
            return {
                actionTitle: ' ',
                actionType: 'icon',
                sortOptions: types.map(function(type) {
                    return options[type];
                }).filter(function(option) {
                    // remove undefined values
                    return option;
                }).sort(function(a, b) {
                    return a.order - b.order;
                })                
            };
        }
    }
])